import ApiService from "@/services/api.service";

export async function getFilterOptions() {
    let response = await ApiService.get("object/filter/get");
    if (response?.status === 200) {
        return response.data;
    }else{
        return null;
    }
}